import { Store } from '@ngrx/store';
import { IController } from 'angular';
import * as angular from 'angular';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { ISubscription } from 'rxjs/Subscription';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import { getStudentSupportsLoadedStatus } from 'Src/ng2/store';
import nvSupportsModule from '../../_module';
import { AssignSupportModalService } from './../../../../../ng2/shared/modals/assign-support/assign-support-modal.service';
import { IStateGoOpts } from './../../../../../ng2/shared/services/prev-state/prev-state.service';

export class CreateSupportStepperCtrl implements IController {
  static $inject = [
    '$rootScope',
    '$scope',
    '$timeout',
    '$mdStepper',
    '$mdDialog',
    '$state',
    '$stateParams',
    '$window',
    'ErrorModal',
    'SpinnerModal',
    'sdcActions',
    'AssignSupportModalService',
    'Store',
    'ImUser',
  ];

  // Bindings
  private currentSupport;
  private supportId: string;
  private editType;
  // goBackStateOpts is used to go back to the ssv when coming from the v3 assign supports modal (CM)
  private goBackStateOpts: IStateGoOpts;
  private studentIds: string[];
  public studentSupportsLoadedSubscription: ISubscription;
  public destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private $rootScope,
    private $scope,
    private $timeout,
    private $mdStepper,
    private $mdDialog,
    private $state,
    private $stateParams,
    private $window,
    private ErrorModal,
    private SpinnerModal,
    private sdcActions,
    private assignSupportModalService: AssignSupportModalService,
    private store: Store<any>,
    private imUser: ImUser,
  ) {}

  $onInit(): void {
    this.$scope.stepper = undefined;
    // cancel
    this.$scope.cancel = () => {
      this.SpinnerModal.activateSpinner('Loading...');

      if (this.goBackStateOpts) this.$state.go(this.goBackStateOpts.name, this.goBackStateOpts.params);
      else this.$state.go('main.school.settings.supports.all-supports');
    };

    // Change stepper title based on type of editing
    if (this.supportId === 'new') this.editType = 'Create';
    else if (this.supportId === 'duplicate') this.editType = 'Duplicate';
    else this.editType = 'Modify';

    // Create or Update
    this.$scope.isNewSupport = this.currentSupport.status ? false : true;

    // Populate effectiveEmail
    this.currentSupport.effectiveEmail = this.imUser.getEffectiveEmail(this.currentSupport.activityLead);

    // Init a stepper with some id
    this.$timeout(() => {
      this.$scope.stepper = this.$mdStepper('support-stepper');
    }, 0);

    // Get the last step number. Used to determine button state
    this.$scope.indexOfLastStep = () => {
      let lastStep: any = _.last(this.$scope.stepper.steps);
      return lastStep.stepNumber;
    };

    // Return to step one on specific scope change
    this.$scope.$watch('stepOneTrigger', () => {
      this.$timeout(() => {
        this.$scope.stepper.goto(0);
      });
    });

    // Calls next step and emits generic done event to parent ctrl
    this.$scope.nextStep = () => {
      this.$scope.stepper.next();
      this.$scope.$emit('stepDone');
    };

    // Calls next step and emits generic done event to parent ctrl
    this.$scope.prevStep = () => {
      this.$scope.stepper.back();
      this.$scope.$emit('stepDone');
    };

    // Save support
    this.$scope.save = () => {
      this.SpinnerModal.activateSpinner('Saving...');
      if (this.$scope.isNewSupport || this.$stateParams.supportId === 'duplicate') {
        // Attach primary outcome metrics
        this.currentSupport.setPrimaryOutcomeMetrics();

        // Added effective email to current support to display to user, but it
        // won't be accepted by the back end so must be omitted here before
        // sending the request.
        this.currentSupport = _.omit(this.currentSupport, ['createdBy', 'schoolYear', 'effectiveEmail']);
        this.currentSupport.$create(
          createdSchoolSupport => {
            this.sdcActions.addSchoolSupport(createdSchoolSupport);

            if (this.$stateParams.supportId === 'duplicate') {
              return this.$state.go('main.school.settings.supports.all-supports');
            } else if (this.$scope.isNewSupport) {
              if (this.$stateParams.supportRequestOrigin === 'regents-prep-wizard') {
                return this.$window.close();
              } else if (this.goBackStateOpts) {
                const studentIdsLength = this.studentIds.length;
                // create student support and redirect to student profile (CM)
                if (studentIdsLength) {
                  const payload = { support: this.currentSupport, studentIds: this.studentIds };
                  this.assignSupportModalService.bulkAssignStudentSupport(payload);
                  this.store.select(getStudentSupportsLoadedStatus).subscribe(loaded => {
                    if (loaded) {
                      this.$state.go(this.goBackStateOpts.name, this.goBackStateOpts.params);
                    }
                  });
                }
              }
              return this.$state.go('main.school.settings.supports.all-supports');
            }
          },
          err => {
            return this.ErrorModal.show(err);
          },
        );
      } else {
        // remove non-editable fields from patch that won't be accepted by the
        // back end so must be omitted here before sending the request.
        // TODO: This should be on support model (JC)
        this.currentSupport = _.omit(this.currentSupport, ['schoolId', 'createdBy', 'effectiveEmail']);
        this.currentSupport.$patch(
          () => {
            this.sdcActions.updateSchoolSupport(this.currentSupport);
            if (this.$stateParams.supportRequestOrigin === 'regents-prep-wizard') {
              return this.$window.close();
            } else {
              return this.$state.go('main.school.settings.supports.all-supports');
            }
          },
          error => {
            return this.ErrorModal.show(error);
          },
        );
      }
    };
  }

  $onDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  // Functions
  dialogAlert = msg => {
    this.$mdDialog.show(
      this.$mdDialog
        .alert()
        .clickOutsideToClose(false)
        .textContent(msg)
        .ok('ok'),
    );
  };

  setExam = (support, examSubject) => {
    if (!examSubject) return;

    const payload = {
      category: 'REGENTS_PREP',
      examSubject,
    };

    support.setMetaData(payload);
  };

  // Get the current step number. Helps determine button states
  currentStep = () => {
    return this.$scope.stepper.currentStep;
  };
}

angular.module(nvSupportsModule).controller('createSupportStepperCtrl', CreateSupportStepperCtrl);
